import { render } from "./ActualSection.vue?vue&type=template&id=704cf6c5"
import script from "./ActualSection.vue?vue&type=script&lang=js"
export * from "./ActualSection.vue?vue&type=script&lang=js"

import "./ActualSection.vue?vue&type=style&index=0&id=704cf6c5&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__